import TagManager from 'react-gtm-module';

export enum AccountMenuLevels {
  level_1 = 'level 1',
  level_2 = 'level 2',
}

export interface TrackAccountMenuEventsProps {
  data: {
    linkUrl: string | null;
    linkText: string | null;
    level: AccountMenuLevels;
  };
}

export const trackAccountMenuEvents = ({
  data,
}: TrackAccountMenuEventsProps) => {
  const { linkUrl, linkText, level } = data;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_account_menu',
      interaction: {
        interaction_location: level,
        link_url: linkUrl,
        link_text: linkText,
      },
    },
  });
};
